<template>
    <div>
        <h4 class="mt-1">
            {{ recoveryDetails.title }}
        </h4>
        <div class="bg-greige my-1 my-md-2 px-1">
            <p><strong>{{ recoveryDetails.text }}</strong></p>
        </div>
        <div class="px-1">
            <div class="mb-1">
                <p
                    v-for="(step, index) in recoveryDetails.stepList"
                    :key="'step-online-'+index"
                    class="d-flex align-items-center mb-0"
                >
                    <span class="font-size-26" :class="'icon-number-' + getIndex(index) +'-wired'" aria-hidden="true" />
                    <span class="ms-1" v-html="step" />
                </p>
            </div>
            <p v-if="recoveryDetails.documentLabel && recoveryDetails.documentList" class="mb-0">
                <span><strong>{{ recoveryDetails.documentLabel }}</strong></span><br>
                <ob1-liste-a-puces
                    :liste-a-puces-dto="recoveryDetails.documentList"
                />
            </p>
            <p class="small mb-2">
                {{ recoveryDetails.mention }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        recoveryDetails: {
            type: Object,
            required: true
        }
    },
    methods: {
        getIndex: function (index) {
            return index + 1;
        }
    }
}
</script>
